module.exports = __webpack_public_path__ + "img/unicorn.fbaf7d30.gif";